module.exports = __webpack_public_path__ + "img/13-03.69dc97b7.jpg";